// @flow

import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import CluiButtonLink from '../ButtonLink';
import {useStripeClui} from '../../helpers/react/provider';

const messages = defineMessages({
  generateRequestTooltip: {
    id: 'docsApp.clui.generateRequestTooltip',
    description: 'Tooltip to geneate request in a new pane',
    defaultMessage: 'Generate request in a new pane',
  },
});

export const GenerateRequestAction = (): React.Node => {
  const {formatMessage} = useIntl();
  const {toggleApiExplorer} = useStripeClui();

  return (
    <CluiButtonLink
      tip={formatMessage(messages.generateRequestTooltip)}
      icon={'guide'}
      onClick={toggleApiExplorer}
    />
  );
};

export default GenerateRequestAction;
